import { formatHrBookingRef } from "../../utils/bookingRefDisplay.js";
import { normalizeSearchToken, traceOrderSearchMatch } from "./operationRequestSearchMatch.js";

function targetVariantsFromNeedle(normalizedNeedle) {
  const core = String(normalizedNeedle ?? "").trim().toLowerCase();
  if (!core) return { digitCore: "", variants: [] };
  const variants = new Set([core, `hr-${core}`, `hr${core}`]);
  if (/^\d{6,}$/.test(core)) {
    variants.add(core);
    variants.add(`hr-${core}`);
    variants.add(`hr${core}`);
  }
  return { digitCore: core, variants: [...variants] };
}

function poolSampleRow(o) {
  return {
    orderId: o?.orderId ?? o?.id ?? null,
    displayOrderNumber: o?.displayOrderNumber ?? null,
    bookingRef: o?.bookingRef ?? o?.raw?.booking_ref ?? null,
    status: o?.status ?? null,
    category: o?.category ?? null,
    customerName: o?.mainContact ?? null,
    hotelName: o?.hotelName ?? null,
  };
}

function fieldBlob(o) {
  const parts = [
    o?.orderId,
    o?.id,
    o?.displayOrderNumber,
    o?.bookingRef,
    o?.raw?.booking_ref,
    o?.raw?.bookingRef,
    formatHrBookingRef(o?.bookingRef ?? o?.raw?.booking_ref),
    o?.mainContact,
    o?.hotelName,
    JSON.stringify(o?.raw?.order_response ?? o?.raw?.orderResponse ?? ""),
  ];
  return parts
    .filter((p) => p != null && String(p).trim() !== "")
    .join(" ")
    .toLowerCase();
}

/**
 * @param {string} rawQuery
 * @param {string} normalizedNeedle
 * @param {unknown[]} pool
 */
export function logOperationRequestSearchPoolTrace(rawQuery, normalizedNeedle, pool) {
  const list = Array.isArray(pool) ? pool : [];
  console.log("[OP_REQUEST_SEARCH_POOL_TRACE]", {
    query: String(rawQuery ?? "").trim(),
    normalizedQuery: normalizedNeedle,
    totalOrders: list.length,
    sample: list.slice(0, 10).map(poolSampleRow),
  });
}

/**
 * @param {string} rawQuery
 * @param {string} normalizedNeedle
 * @param {unknown[]} pool
 */
export function logOperationRequestSearchTargetTrace(rawQuery, normalizedNeedle, pool) {
  const list = Array.isArray(pool) ? pool : [];
  const { digitCore, variants } = targetVariantsFromNeedle(normalizedNeedle);
  const matchedCandidates = [];

  for (const o of list) {
    const blob = fieldBlob(o);
    const hitVariant = variants.find((v) => blob.includes(v));
    const hitCore = digitCore && blob.includes(digitCore);
    if (hitVariant || hitCore) {
      matchedCandidates.push({
        ...poolSampleRow(o),
        matchedVariant: hitVariant ?? digitCore,
        matchTrace: traceOrderSearchMatch(o, normalizedNeedle),
      });
    }
  }

  console.log("[OP_REQUEST_SEARCH_TARGET_TRACE]", {
    query: String(rawQuery ?? "").trim(),
    normalizedQuery: normalizedNeedle,
    targetDigitCore: digitCore,
    targetVariants: variants,
    poolTotal: list.length,
    matchedCandidates,
  });
}
